import { useEffect, useState } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'

import { ItemsList } from './items-list.component'
import { TableList } from './table-list.component'
import { ModalTitle } from './modal-title.component'
import { IFilter } from 'src/components/filter/types/filter.types'

import { countOffset } from 'src/common/utils'
import { countTotalPages } from 'src/common/utils/count-pages.util'
import { useStyles } from './styles'
import {
  initialWhiteLabelPartners,
  useWhiteLabelPartners,
} from 'src/hooks/white-label-partners/useWhiteLabelPartners.hook'
import { usePagination } from 'src/hooks'

const defaultPage = 0
const defaultLimit = 50

interface IProps {
  accountId: string
}

const WhiteLabelContent = ({ accountId }: IProps) => {
  const [filter, setFilter] = useState<IFilter>(initialWhiteLabelPartners)
  const { page, setPage } = usePagination(defaultPage, defaultLimit)

  const { data: wlp } = useWhiteLabelPartners({
    ...filter,
    offset: countOffset(page, defaultLimit),
    limit: defaultLimit,
  })

  const classes = useStyles()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  useEffect(() => {
    setPage(defaultPage)
  }, [filter, setPage])

  const totalPages = countTotalPages(wlp?.count ?? 0, defaultLimit)

  return (
    <>
      <div className={classes.upperWrapper}>
        <ModalTitle />
        <div>
          {isTablet ? (
            <ItemsList items={wlp?.data} accountId={accountId} />
          ) : (
            <TableList items={wlp?.data} accountId={accountId} />
          )}
        </div>
      </div>
    </>
  )
}

export { WhiteLabelContent }
